import api from './client';

// ── Xero Sync Health ────────────────────────────────────────────────────────

export interface XeroHealthData {
  suppliers: {
    total: number;
    linked: number;
    unlinked: { id: string; name: string }[];
  };
  clients: {
    total: number;
    linked: number;
    unlinked: { id: string; name: string; jobCount: number }[];
  };
  bills: {
    approvedWithSubHire: number;
    withoutBills: { quoteId: string; jobId: string; jobNumber: number | null; jobName: string }[];
  };
}

// ── Microsoft Entra Secret ──────────────────────────────────────────────────

export interface EntraSecretData {
  configured: boolean;
  expiresAt?: string;
  daysUntilExpiry?: number;
  status?: 'ok' | 'warning' | 'expired';
  hasSecret?: boolean;
  secretPreview?: string;
  updatedAt?: string;
}

export const toolsApi = {
  getXeroHealth: () =>
    api.get<XeroHealthData>('/tools/xero-health').then((r) => r.data),

  getEntraSecret: () =>
    api.get<EntraSecretData>('/tools/entra-secret').then((r) => r.data),

  setEntraSecret: (data: { expiresAt: string; secret?: string }) =>
    api.put<{ ok: boolean; secretUpdated: boolean }>('/tools/entra-secret', data).then((r) => r.data),

  clearEntraSecret: () =>
    api.delete('/tools/entra-secret').then((r) => r.data),
};
